const useTMLPowerformUrl = () => {
  const tmPowerformUrl =
    'https://powerforms.docusign.net/661ffbab-979e-4a17-9b5c-2f392cdcfb6c?env=na2&acct=7276ba92-91bc-477e-9e09-e0c472fc38a8&accountId=7276ba92-91bc-477e-9e09-e0c472fc38a8';

  return { tmPowerformUrl };
};

export default useTMLPowerformUrl;
